import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import {UserService} from '../../../services/user.service';
import {NgxSpinnerService} from 'ngx-spinner';
import Swal from 'sweetalert2';
import {SiteService} from '../../../services/site.service';
import {ConfigService} from '../../../services/config.service';
import { OrderPipe } from 'ngx-order-pipe';
import { ExportToCsv } from 'export-to-csv';
import {Router} from '@angular/router';
import {LoginService} from '../../../services/login.service';

@Component({
    selector: 'app-superviseur',
    templateUrl: './superviseur.component.html',
    styleUrls: ['./superviseur.component.css'],
    standalone: false
})
export class SuperviseurComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);
  // tslint:disable-next-line:max-line-length
  constructor(private orderPipe: OrderPipe, private router: Router, private userService: UserService, private loginService: LoginService, private spinner: NgxSpinnerService, private siteService: SiteService, private configService: ConfigService) {
    this.sortedCollection = orderPipe.transform(this.users, 'user.name');
  }
  page = 1;
  order = 'user.name';
  reverse = false;
  dateOrder: string = '';
  dateReverse = false;
// tslint:disable-next-line:variable-name radix
  public profile_id = parseInt(localStorage.getItem('profile_id'));
  // tslint:disable-next-line:variable-name radix
  public site_id = parseInt(localStorage.getItem('site_id'));
  // tslint:disable-next-line:variable-name radix
  public site_connected_id = parseInt(localStorage.getItem('site_id'));
  // tslint:disable-next-line:variable-name
  public user_conntected = JSON.parse(localStorage.getItem('currentUser'));
  // tslint:disable-next-line:max-line-length variable-name
  public admin_login = this.user_conntected.login;
  public users: any;
  public Allusers: any;

  // tslint:disable-next-line:variable-name
  public user_sites: any;
  // tslint:disable-next-line:variable-name
  public user_profile: any;
  // tslint:disable-next-line:variable-name
  public count_superviseurs: any;
  show = 10;
  vQuery: string;
  addingSuccess: boolean;
  showLoadConnection: boolean;
  sites: any;
  sortedCollection: any[];
  // tslint:disable-next-line:variable-name
  showLoader = true;
  public userToExport: any[];
  // tslint:disable-next-line:variable-name
  showLabel = true;

  // tslint:disable-next-line:variable-name
  showLoaderExport: boolean;
  // tslint:disable-next-line:variable-name
  displayBody = true;
  public entityType = this.configService.entityType;

  ngOnInit() {
    this.configService.checkUSerAccessByProfile(this.profile_id);
    // @ts-ignore
    this.get_list_superviseurs(this.profile_id, this.site_id);
    this.get_list_sites();
  }

    // La méthode de filtrage qui combine le nom et prénom
  getFilteredUsers() {
    if (!this.vQuery || this.vQuery.trim() === '') {
      return this.users;  // Retourne tous les utilisateurs si aucun texte n'est saisi
    }

    const searchTerms = this.vQuery.toLowerCase().split(' ').filter(term => term.trim() !== '');

    return this.users.filter(user => {
      const name = user.user.name ? user.user.name.toLowerCase() : '';
      const firstname = user.user.firstname ? user.user.firstname.toLowerCase() : '';

      // Vérifie si tous les termes de recherche se trouvent dans le nom ou le prénom
      return searchTerms.every(term => name.includes(term) || firstname.includes(term));
    });
  }


  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    } else {
      this.reverse = false;
    }

    this.order = value;
    this.dateOrder = ''; // Réinitialiser le tri par date


    // Appliquer le tri après le filtrage et la normalisation
    this.users.sort((a, b) => {
      const fieldA = a.user && a.user[value] ? a.user[value].normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "").toLowerCase(): '';

      const fieldB = b.user && b.user[value]? b.user[value].normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "").toLowerCase(): '';

      // Comparer les deux champs pour déterminer l'ordre de tri
      return this.reverse
        ? fieldB.localeCompare(fieldA)
        : fieldA.localeCompare(fieldB);
    });
  }

   // Méthode pour le tri des dates
   setDateOrder(value: string) {
    if (this.dateOrder === value) {
      this.dateReverse = !this.dateReverse;
    } else {
      this.dateReverse = false;
    }
    this.dateOrder = value;
    this.order = ''; // Réinitialiser le tri par nom/prénom


    // Tri par dates
    this.users.sort((a, b) => {
      const dateA = this.convertToDate(a.user[value.split('.')[1]]);
      const dateB = this.convertToDate(b.user[value.split('.')[1]]);
      if (dateA && dateB) {
        return this.dateReverse
          ? dateB.getTime() - dateA.getTime()
          : dateA.getTime() - dateB.getTime();
      }
      if (!dateA && dateB) return this.dateReverse ? -1 : 1;
      if (dateA && !dateB) return this.dateReverse ? 1 : -1;
      return 0;
    });
  }

  // tslint:disable-next-line:variable-name
  get_list_superviseurs(profile_id, site_id) {
    this.spinner.show();
    this.userService.getListSuperviseur(profile_id, site_id)
      .subscribe(res => {
        // @ts-ignore
        this.count_superviseurs = res.data.length;
         // @ts-ignore
         this.users = res.data.map(user => {
          // Tri sur les noms et prénoms pour un affichage uniforme pour les espaces et les Majuscules
          return {
            ...user,
            user: {
              ...user.user,
              name: user.user.name ? user.user.name.replace(/\s+/g, "").toUpperCase() : '', // Convertir en majuscules
              firstname: user.user.firstname ? user.user.firstname.replace(/\s+/g, "").toUpperCase() : '', // Convertir en majuscules
            }
          };
        });
        this.Allusers = [...this.users];

        // Appliquer un tri initial pour s'assurer que la liste est ordonnée
        this.setOrder('name');
        this.spinner.hide();
      }, (err) => {
        console.log(err);
        this.spinner.hide();
      });
  }
  increaseShow() {
    // @ts-ignore
    this.spinner.show();
    this.show += 10;
    this.spinner.hide();
  }



  // tslint:disable-next-line:variable-name
  delete_client(id_client: any) {
    Swal.fire({
      title: this.runtimeTranslate.instant('alerts.confirmDelete'),
      text: this.runtimeTranslate.instant('alerts.irreversible'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.runtimeTranslate.instant('alerts.yesDelete'),
      cancelButtonText: this.runtimeTranslate.instant('common.cancel')
    }).then((result) => {
      if (result.value) {
        // @ts-ignore
        this.userService.deleteClient(id_client)
          .subscribe(res => {
            this.addingSuccess = true;
            this.get_list_superviseurs(this.profile_id, this.site_id);
          }, (err) => {
            console.log(err);
          });
        Swal.fire(
          this.runtimeTranslate.instant('alerts.deleted'),
          this.runtimeTranslate.instant('alerts.supervisorDeleted'),
          'success'
        );
      }
    });
  }
  get_list_sites() {
    this.siteService.getSite()
      .subscribe(res => {
        this.sites = res.data;
      }, (err) => {
        console.log(err);
      });
  }
  // tslint:disable-next-line:variable-name
  get_client_sites(id_site, profile) {
    this.spinner.show();
    this.siteService.get_site_superviseur(id_site, profile)
      .subscribe(res => {
        // @ts-ignore
        this.count_superviseurs = res.data.length;
          // @ts-ignore
        this.users = res.data;
        this.Allusers = [ ...this.users ];
        this.spinner.hide();
      }, (err) => {
        console.log(err);
      });
  }

  filterSite(value) {
    if (value === 'Tout') {
      // Si "Tout" est sélectionné, chargez tous les superviseurs
      this.get_list_superviseurs(this.profile_id, this.site_id);
    } else {
      // Si un site spécifique est sélectionné, chargez les superviseurs pour ce site
      this.get_client_sites(value, this.profile_id);
    }
  }

  exporter() {
    const dataToExport = [];

    if (this.profile_id !== 11) {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.runtimeTranslate.instant('alerts.exportSupervisors'),
        filename: 'liste_superviseur_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: [this.runtimeTranslate.instant('exportHeaders.lastName'), this.runtimeTranslate.instant('exportHeaders.firstName'), this.runtimeTranslate.instant('exportHeaders.startDate'), this.runtimeTranslate.instant('exportHeaders.endDate'), this.runtimeTranslate.instant('exportHeaders.profile'), this.runtimeTranslate.instant('exportHeaders.status')]
      };

      this.users.forEach((rdata, index) => {
        try {
          const user = rdata?.user || {};
          const data = {
            'Noms': user.name || '',
            'Prénoms': user.firstname || '',
            'Date de début': user.start_date && user.start_date !== '01/01/1970' ? user.start_date : '',
            'Date de fin': user.end_date && user.end_date !== '01/01/1970' ? user.end_date : '',
            'Profil': user.profile_name || '',
            'Statut': user.hasOwnProperty('active') ? (user.active === 1 ? 'Actif' : 'Non actif') : 'Inconnu'
          };
          dataToExport.push(data);
        } catch (e) {
          console.error(`[EXPORT - L${index}] Erreur de traitement user local :`, rdata, e);
        }
      });

      console.log('[EXPORT] Données exportées superviseurs (local) :', dataToExport);
      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(dataToExport);
    } else {
      this.showLoaderExport = true;
      this.spinner.show();

      this.userService.getSuperviseurs_export(this.profile_id, this.site_id)
        .subscribe(
          (res: any) => {
            this.userToExport = res?.data || [];
            this.spinner.hide();

            const options = {
              fieldSeparator: ';',
              quoteStrings: '"',
              decimalSeparator: '.',
              showLabels: true,
              showTitle: true,
              title: this.runtimeTranslate.instant('alerts.exportSupervisors'),
              filename: 'liste_superviseur_' + this.formatDate(),
              useTextFile: false,
              useBom: true,
              useKeysAsHeaders: false,
              headers: [this.runtimeTranslate.instant('exportHeaders.lastName'), this.runtimeTranslate.instant('exportHeaders.firstName'), this.runtimeTranslate.instant('exportHeaders.sites'), this.runtimeTranslate.instant('exportHeaders.startDate'), this.runtimeTranslate.instant('exportHeaders.endDate'), this.runtimeTranslate.instant('exportHeaders.profile'), this.runtimeTranslate.instant('exportHeaders.status')]
            };

            this.userToExport.forEach((rdata, index) => {
              try {
                const user = rdata?.user || {};
                const siteNames = Array.isArray(rdata?.sites)
                  ? rdata.sites.map(site => site.name).join(' - ')
                  : '';

                const data = {
                  'Noms': user.name || '',
                  'Prénoms': user.firstname || '',
                  'Sites': siteNames,
                  'Date de début': user.start_date && user.start_date !== '01/01/1970' ? user.start_date : '',
                  'Date de fin': user.end_date && user.end_date !== '01/01/1970' ? user.end_date : '',
                  'Profil': user.profile_name || '',
                  'Statut': user.hasOwnProperty('active') ? (user.active === 1 ? 'Actif' : 'Non actif') : 'Inconnu'
                };

                dataToExport.push(data);
              } catch (e) {
                console.error(`[EXPORT - L${index}] Erreur de traitement userToExport :`, rdata, e);
              }
            });

            console.log('[EXPORT] Données exportées superviseurs (API) :', dataToExport);
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(dataToExport);
            this.showLoaderExport = false;
          },
          err => {
            console.error('Erreur export superviseurs :', err);
            this.spinner.hide();
            this.showLoaderExport = false;
          }
        );
    }
  }




  formatDate() {
    // tslint:disable-next-line:one-variable-per-declaration
    const d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    const hour = d.getHours();
    const minute = d.getMinutes();
    const seconde = d.getSeconds();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    const dateJoin = [year, month, day].join('');
    const hourJOin = [hour, minute, seconde].join('');
    return [dateJoin, hourJOin].join('_');
  }

  // tslint:disable-next-line:variable-name
  prise_en_main(login_t, email_t) {
    this.showLoadConnection = true;
    this.spinner.show();
    const body = {
      login: login_t,
      email: email_t
    };
    // @ts-ignore
    this.userService.take_in_hand(body)
      .subscribe(res => {
        this.loginService.logout_take_in_hand();
        // @ts-ignore
        if (res.status === 'success') {
          // @ts-ignore
          localStorage.setItem('currentUser', JSON.stringify(res.user));
          localStorage.setItem('takeInHand', 'yes');
          localStorage.setItem('admin_login', this.admin_login);
          // @ts-ignore
          localStorage.setItem('tokenCurrentConnected', JSON.stringify(res.token));
          // @ts-ignore
          this.loginService.currentUserSubject.next(res.user);
          // @ts-ignore
          localStorage.setItem('profile_id', res.profile_id);
          // @ts-ignore
          localStorage.setItem('site_id', res.site_id);
          // @ts-ignore
          if (res.profile_id === 10 || res.profile_id === 8 || res.profile_id === 13) {
            window.location.reload();
            this.router.navigate(['dashboard/inspector']);
            return false;
          }
          window.location.reload();
          this.router.navigate(['dashboard/administrator']);
          return false;

        }

        this.spinner.hide();
      }, (err) => {
        console.log(err);
      });
  }
  // tslint:disable-next-line:variable-name
  listingSiteUser(user_id, profile_id) {
    //this.displayBody = false;
    this.showLoader = true;
    this.showLabel = false;
    this.userService.getUserSiteAnd_Profil_InFront(user_id, profile_id)
      .subscribe(res => {
        this.showLabel = true;
        // @ts-ignore
        this.user_sites = res.sites;
        this.showLoader = false;

      }, (err) => {
        console.log(err);
      });
  }
  get_user_profile(user_id, profile_id) {
    this.userService.getUserSiteAnd_Profil_InFront(user_id, profile_id)
      .subscribe(res => {
        // @ts-ignore
        this.user_profile = res.profile;
      }, (err) => {
        console.log(err);
      });
  }
  handlePageChange(event) {
    this.page = event;
  }


  convertToDate(dateString: string | null | undefined): Date | null {
    // Vérifiez si dateString est défini et non vide
    if (!dateString || dateString.trim() === '') {
        return null;
    }

    // Séparez les parties du jour, du mois et de l'année
    const [day, month, year] = dateString.split('/').map(Number);

    // Vérification des valeurs
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return null;
    }

    // Créez un objet Date
    const date = new Date(year, month - 1, day);

    // Vérification si la date est valide
    if (!isNaN(date.getTime())) {
        return date;
    }

    return null;
  }
}
